import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

export const getDetailProforma = async (
  oid: number | null
): Promise<string | undefined> => {
  try {
    const res = await apiClient.post<ApiResponse<string | undefined>>(
      Endpoints.Depo20DetalleProforma,
      {
        oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
